import { render } from "./NewReactionForm.vue?vue&type=template&id=42de89c4&scoped=true"
import script from "./NewReactionForm.vue?vue&type=script&lang=js"
export * from "./NewReactionForm.vue?vue&type=script&lang=js"

import "./NewReactionForm.vue?vue&type=style&index=0&id=42de89c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42de89c4"]])

export default __exports__